export const TIME_PRESETS = [
  {
    key: 'last-00:01:00:00',
    label: 'Last 1 hour'
  },
  {
    key: 'last-07:00:00:00',
    label: 'Last 7 days'
  },
  {
    key: 'today',
    label: 'Today'
  },
  {
    key: 'last-00:04:00:00',
    label: 'Last 4 hours'
  },
  {
    key: 'last-30:00:00:00',
    label: 'Last 30 days'
  },
  {
    key: 'yesterday',
    label: 'Yesterday'
  },
  {
    key: 'last-00:12:00:00',
    label: 'Last 12 hours'
  },
  {
    key: 'last-90:00:00:00',
    label: 'Last 90 days'
  },
  {
    key: 'week',
    label: 'This Week'
  },
  {
    key: 'last-00:24:00:00',
    label: 'Last 24 hours'
  },
  {
    key: 'last-180:00:00:00',
    label: 'Last 180 days'
  },
  {
    key: 'month',
    label: 'This Month'
  },
  {
    key: 'all',
    label: 'All Data'
  }
] as const;

export const ALL_TIME_FILTER = 'all|C';
export const DEFAULT_TIME_FILTER = 'last-07:00:00:00|C';

export default TIME_PRESETS;
